<cmp-component-card
  heading="Settings"
  [maxWidth]="500"
  description="Global application settings"
  [link]="undefined"
  [closeModal]="onClose">
  <form class="px-[5px]" [formGroup]="settingsForm">
    <div class="flex items-center justify-between pb-[10px] max-mobile-small:px-6">
      <div>{{ 'language' | translate }} {{ settingsForm.controls.language.disabled ? '(Disabled)' : '' }}</div>
      <div class="w-60">
        <!-- <cmp-select [items]="languages" formControlName="language" height="200"></cmp-select> -->
      </div>
    </div>
    <div class="flex items-center justify-between py-[10px] max-mobile-small:px-6">
      <div>{{ 'dark_mode' | translate }} {{ settingsForm.controls.language.disabled ? '(Disabled)' : '' }}</div>
      <div class="w-60">
        <cmp-toggle formControlName="darkMode" size="medium"></cmp-toggle>
      </div>
    </div>
  </form>

  <button class="mt-[20px] button button--secondary ml-auto mr-0" (click)="onClose()">
    {{ 'close' | translate }}
  </button>
</cmp-component-card>
